export default __webpack_public_path__ + "ui/assets/img/attention-invert-16.svg";